// Create in Sketch

export default function MoveIcon ({}) {

  return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <g transform="translate(9.000000, 8.000000)" stroke="#000000" strokeWidth="1.5">
                  <path d="M6,11.0833333 L3,14 M3,14 L0,11.0833333 M3,14 L3,0" id="Shape"></path>
              </g>
              <g transform="translate(2.000000, 9.000000)" stroke="#000000" strokeWidth="1.5">
                  <path d="M2.91666667,6 L0,3 M0,3 L2.91666667,0 M0,3 L14,3" id="Shape"></path>
              </g>
              <g transform="translate(8.000000, 9.000000)" stroke="#000000" strokeWidth="1.5">
                  <path d="M11.0833333,0 L14,3 M14,3 L11.0833333,6 M14,3 L0,3" id="Shape"></path>
              </g>
              <g transform="translate(9.000000, 2.000000)" stroke="#000000" strokeWidth="1.5">
                  <path d="M0,2.91666667 L3,0 M3,0 L6,2.91666667 M3,0 L3,14" id="Shape"></path>
              </g>
          </g>
      </svg>
  </>
}
